'use strict';

/**
 * Helper module for initialization popover elements
 *
 * @module popover
 */

const { queryFirst, queryAll, hasClass } = require('./domUtil');

const phInfoPopover = queryFirst('.ph-number-info-popover .content-asset');
const fpoInfoPopover = queryFirst('.fpo-info-popover .content-asset');
const checkoutBenefitsInfoPopover = queryFirst('.checkout-benefits-info .checkout-benefits-info-content');
const cvvInfoPopover = queryFirst('.cvv-info-popover .cvv-info-popover-content');
const giftCardInfoPopover = queryFirst('.gift-card-number-info-popover .content-asset');
const deliveryFeeInfoPopover = queryFirst('.delivery-fee-info-popover .content-asset');
const boltSignoutMessage = queryFirst('.bolt-logout-button .bolt-sign-out');
const earlyAccessMessage = queryFirst('.loyalty-early-access-lock-container .early-access-container-tooltip');
const giftReturnNumberInfoPopover = queryFirst('.gift-return-order-no-popover .content-asset');
const earlyAccessLockedSelector = '.loyalty-early-access-locked';
const pdpChatWrapper = queryFirst('.pdp-chat');
const pdpChatPopover = queryFirst('.js-toggle-chat-popover');
const pdpChatContainer = queryFirst('.pdp-chat-container');
const keepUserSignedInPopoverCheckoutPage = queryFirst('.existing-customer-sheet .keep-user-signed-in');

// default popover options on hover
const POPOVER_HOVER_BOTTOM = {
    trigger: 'hover',
    placement: 'bottom',
    html: true
};

const initPopover = (selector, container, ...options) => {
    const popoverOptions = Object.assign({}, POPOVER_HOVER_BOTTOM, ...options);
    $(selector, container || document.body).popover(popoverOptions);
};

// default popover option on click
const POPOVER_CLICK_BOTTOM = {
    trigger: 'click',
    placement: 'bottom',
    html: true
};

/*
 * Handle clicks outside of popover in order to close it
 */
const initPopoverClose = container => {
    // since it can be called dynamically, first we get rid of old events
    $('[data-toggle="popover"]', container || document.body)
        .off('shown.bs.popover')
        .on('shown.bs.popover', function (e) {
            const { target } = e;
            $(document).one('click', function (clickEvent) {
                const clicked = clickEvent.target;
                if (clicked !== target && clicked.parentElement !== target && $('.popover.show').length) {
                    $(target).trigger('click');
                }
            });
        });
};

/*
 * Assign custom close event on custom selector
 */
const initPopoverCloseSelector = container => {
    $('[data-close-popover-selector]', container || document.body).on('click', function () {
        const tooltipSelector = $(this).data('close-popover-selector');
        $(tooltipSelector).popover('hide');
    });
};

/**
 * Initializing popover for promotions on a page
 */
const initPopoverPromotions = () => {
    queryAll('.promotions-info').forEach(button => {
        const popoverContent = queryFirst('.promotions-info-popover .promotions-info-popover-content', button.parentElement);

        $(button).popover({
            trigger: 'click',
            placement: 'bottom',
            html: true,
            content: popoverContent
        });
    });
};

/**
 * Initializing popover for strike hearts on a page
 */
const initPopoverWishList = () => {
    queryAll('.strike-wish-list').forEach(button => {
        const popoverContent = button.dataset.content;
        $(button).popover({
            placement: 'bottom',
            trigger: 'hover click',
            html: true,
            content: popoverContent
        });
    });
};

/**
 * Early access locked message popover
 */
const initPopoverEarlyAccessLocked = container => {
    const earlyAccessMessage = queryFirst('.loyalty-early-access-lock-container .early-access-container-tooltip');

    if (hasClass(queryFirst(earlyAccessLockedSelector), 'has-early-access-container')) {
        initPopover(earlyAccessLockedSelector, container, {
            content: earlyAccessMessage
        });
    }
};

const initPopoverAllLocal = container => {
    const birthdayInfoPopover = queryFirst('.birthday-info-popover .content-asset');
    const keepUserSignedInPopover = queryFirst('.remember-me .keep-user-signed-in');
    const keepUserSignedInContainer = queryFirst('.remember-me .logged-in-user-notification');

    initPopover('.ph-number-info', container, {
        content: phInfoPopover
    });

    const popoverIcons = queryAll('.loyalty-tooltip-icon');
    popoverIcons.forEach(tooltipIcon => {
        const popContent = queryFirst('.loyalty-tooltip-popover', tooltipIcon.parentElement);
        initPopover(tooltipIcon, container, {
            content: popContent,
            placement: 'bottom'
        });
    });

    initPopover('.birthday-info', container, {
        content: birthdayInfoPopover,
        customClass: 'birthday-popover'
    });

    initPopover('.fpo-info', container, {
        content: fpoInfoPopover
    });

    initPopover('.checkout-benefits-info', container, {
        container: '.new-customers',
        offset: '160 0',
        content: checkoutBenefitsInfoPopover
    });

    initPopover('.cvv-info', container, {
        content: cvvInfoPopover
    });

    initPopover('.gift-return-order-no', container, POPOVER_CLICK_BOTTOM, {
        content: giftReturnNumberInfoPopover
    });

    initPopover('.gift-card-number-info', container, {
        content: giftCardInfoPopover
    });

    initPopover('.delivery-fee-info', container, {
        content: deliveryFeeInfoPopover
    });

    initPopover('.bolt-logout-button-container', container, POPOVER_CLICK_BOTTOM, {
        content: boltSignoutMessage
    });

    initPopoverPromotions();
    initPopoverWishList();

    initPopoverEarlyAccessLocked(container);

    initPopover(keepUserSignedInPopover, container, POPOVER_CLICK_BOTTOM, {
        content: keepUserSignedInContainer
    });

    initPopover(keepUserSignedInPopoverCheckoutPage, container, {
        content: keepUserSignedInContainer
    });

    initPopover(pdpChatPopover, container, POPOVER_CLICK_BOTTOM, {
        html: true,
        container: pdpChatWrapper,
        placement: 'bottom',
        content: pdpChatContainer
    });

    initPopoverClose(container);
    initPopoverCloseSelector(container);
};

/**
 * Attach search related events
 */
function attachSearchEvents() {
    const body = $(document.body); // Використовуємо jQuery для вибору body

    body.on('search:updateProducts', () => {
        initPopoverAllLocal();
    });

    body.on('search:showMore', () => {
        initPopoverAllLocal();
    });

    body.on('search:densityChange', () => {
        initPopoverAllLocal();
    });

    document.addEventListener('slot-loaded', e => {
        const { target } = e;
        initPopoverAllLocal(target);
    });

    body.on('sheet:injectForm', () => {
        initPopoverAllLocal();
    });
}

/**
 * All of usual popover elements on site
 * TODO: Ideally refactor to something dynamical, when it appear in DOM - initialize it
 */
const initPopoverAll = () => {
    attachSearchEvents();
    initPopoverAllLocal();
};

module.exports.POPOVER_HOVER_BOTTOM = POPOVER_HOVER_BOTTOM;
// export the initialization function for places where popover may be initialized dynamically
module.exports.initPopoverClose = initPopoverClose;
module.exports.initPopoverCloseSelector = initPopoverCloseSelector;
// export function for single initialization of popover
module.exports.initPopover = initPopover;
module.exports.initPopoverPromotions = initPopoverPromotions;
module.exports.initPopoverEarlyAccessLocked = initPopoverEarlyAccessLocked;
module.exports.initPopoverAll = initPopoverAll;
module.exports.initPopoverWishList = initPopoverWishList;
